<script>

    import { email, pushRegistration, mode } from '../store';
    import { Button, TextField, Switch, Icon } from 'svelte-materialify';
    import { mdiArrowRight } from '@mdi/js';

    export let _window;
    export let swreg;

    // Declare server key
    const SERVER_KEY = urlBase64ToUint8Array("BA_ux1tBYWizPxZCqekybuVRDgXhsOgrlHWqGCN-kpBa2odeXTZvD9a7kDlD85fyYFwX-4J1H3mZMkrIadsFfSo");

    // Declare old server key
    const OLD_SERVER_KEY = urlBase64ToUint8Array("BFaNs8n5JYn2ozrR2z1-FfuNXSvCBQxyUPvR1Z1uNQS0c8ZLS2qJhDAH_U9IiFkECR5WOGBP4aw9scgHZazDvNg")

    let _email = "";
    let _push = false;
    let isEmailValid = false;
    let _mode;
    let updateRules = true;

    mode.subscribe(val => _mode = val);

    const emailRules = [
        (v) => {
            if(!v)
                isEmailValid = false;
            return !!v || 'Required'
        },
        (v) => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(pattern.test(v))
                isEmailValid = true;
            else
                isEmailValid = false;
            return pattern.test(v) || 'Invalid e-mail.';
        },
    ];

    let isNotificationDisabled = false;

    // Subscribe to receive notifications
    function subscribeNotifications() {

        // Subscribe to push manager
        swreg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: SERVER_KEY
        }).then(
            function(pushSubscription) {

                // Log notifications enabled
                console.log("Push notification -> enabled");

                // Update push registration
                pushRegistration.set( pushSubscription );

                // Log push subscription
                console.log(pushSubscription);
            
            }, function(error) {

                // Log notifications error
                console.log("Push notification -> error");

                // Log error
                console.log(error);

                // Set switch OFF
                _push = false;

                // Disabled switch
                isNotificationDisabled = true;

                // Reset push registration
                pushRegistration.set(null);

            }
        );

    }

    function askNotification() {

        // Check if notifications are allowed inside the browser
		if (!("Notification" in window)) {

            // Alert user
			alert("This browser does not support desktop notification");
		
            // Return
            return;
        }

        // Ask fot notifcations permission
		Notification.requestPermission().then(function (_permission) {

            // Log permission status
            console.log("PERMISSION: ", _permission);

            // Update notification disabeld variable
			isNotificationDisabled = _permission !== "granted";

            // Check if notification permission is granted
			if(_permission === "granted"){

                // Log notifications enabled
                console.log("Notification permission: ENABLED");

                // Log SW REGISTRATION
                console.log( swreg );

                // Subscribe to notifications
                subscribeNotifications();


			} else {

                // Log notifications enabled
                console.log("Notification permission: DISABLED");

                // Set switch OFF
                _push = false;

                // Disabled switch
                isNotificationDisabled = true;

                // Reset push registration
                pushRegistration.set(null);

            }
		});
	}

    function urlBase64ToUint8Array(base64String) {
		var padding = '='.repeat((4 - base64String.length % 4) % 4);
		var base64 = (base64String + padding)
			.replace(/\-/g, '+')
			.replace(/_/g, '/');

		var rawData = window.atob(base64);
		var outputArray = new Uint8Array(rawData.length);

		for (var i = 0; i < rawData.length; ++i) {
			outputArray[i] = rawData.charCodeAt(i);
		}
		return outputArray;
	}

    function emailKeyDown(e) {
        if (e.which === 32)
            e.preventDefault();
    }

    function emailChange(e) {
        _email = _email.replace(/\s/g, "");
        updateRules = false;
        setTimeout(() => {
            updateRules = true;
        }, 0);
        emailRules.forEach(call => call(_email));
    }

</script>

<main>

    <div class="container-info pa-3">

        <div class="box white rounded elevation-1 pa-3 black-text">

            <h5 class="text-h5 mt-4 mb-6">
                Avviso di chiusura
            </h5>

            <div class="text-body-1 mt-1">
                Inserisci l'email in modo tale da ricevere un avviso quando la provetta dovrà essere chiusa, in basso puoi attivare anche le notifiche push al fine di ricevere oltre all'email anche una notifica sul telefono
            </div>

            {#if updateRules}
                <TextField on:keydown={emailKeyDown} on:change={emailChange} rules={emailRules} class="mt-6" color="green" bind:value={_email} filled>
                    Email *
                </TextField>
            {/if}

            {#if _mode === "start"}
            
                <Switch disabled={!("Notification" in window) || isNotificationDisabled} class="mt-6" color="green" bind:checked={_push} on:change={() => {

                    // Check switch status
                    if(_push) {

                        // Ask for notification
                        askNotification();

                    } else {

                        // Reset push registration
                        pushRegistration.set(null);

                    }

                }}>
                    Notifiche push
                </Switch>

            {/if}

            <div class="action pt-6">

                <Button disabled={!isEmailValid} rounded depressed class="green white-text" on:click={() => {
                    email.set(_email);
                    _window.next();
                }}>
                    Continua
                    <Icon path={mdiArrowRight} class="ml-2" />
                </Button>

                <Button rounded depressed outlined class="red-text" on:click={_window.previous}>
                    Torna indietro
                </Button>
                
            </div>

        </div>

    </div>

</main>

<style>

    main {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
    }

    .container-info {
        position: absolute;
        width: 100%;
        height: 100%;
        display: grid;
        place-items: center;
    }

    .box {
        width: 100%;
        height: auto;
        max-height: 95%;
        overflow-y: auto;
    }

    .box > div {
        width: 100%;
        display: grid;
        place-items: center;
        text-align: justify;
    }
    
</style>